<template>
    <div class="desktop-sign-in-menu">
        <SkyPopoverMenu v-model:active="isOpen">
            <template #trigger="{ attrs: popoverAttrs, handlers }">
                <a
                    id="account-dropdown-desktop"
                    href="#"
                    class="navbar-btn"
                    data-test="account-dropdown-desktop"
                    v-bind="popoverAttrs"
                    :title="
                        $formatMessage({
                            defaultMessage: 'Button to open sign in options menu',
                            id: 'globals.desktopSignInMenu.menuTitle',
                        })
                    "
                    v-on="handlers">
                    <div class="desktop-sign-in-menu__trigger">
                        <SkyText
                            variant="sm"
                            class="desktop-sign-in-menu__text nav-link-base nav-link-brand">
                            {{ $formatMessage(globalMessages.signIn) }}
                        </SkyText>
                        <CxFontAwesomeIcon action="collapseDown"> </CxFontAwesomeIcon>
                    </div>
                </a>
            </template>

            <template #menu="{ attrs: menuAttrs }">
                <SkyDropdownMenu
                    v-bind="menuAttrs"
                    class="user-info-dropdown-menu"
                    data-test="user-info-dropdown-menu">
                    <SkyDropdownMenuItem :href="config.signIn">
                        {{ $formatMessage(globalMessages.signIn) }}
                    </SkyDropdownMenuItem>

                    <SkyDropdownMenuItem :href="config.registerUrl">
                        {{ $formatMessage(globalMessages.register) }}
                    </SkyDropdownMenuItem>
                </SkyDropdownMenu>
            </template>
        </SkyPopoverMenu>
    </div>
</template>

<script>
    import CxFontAwesomeIcon from "@eg_ui/src/components/globals/CxFontAwesomeIcon/CxFontAwesomeIcon.vue";
    import { toggle } from "@eg_ui/src/mixins/globals/toggle";
    import { globalMessages } from "@eg_ui/src/translations/globals";
    import { GLOBAL_EVENTS, globalEventHandler } from "@eg_ui/src/utils/libs";

    export default {
        components: {
            CxFontAwesomeIcon,
        },
        mixins: [toggle],
        props: {
            config: { type: Object, default: () => {} },
            /* structure expected to be as follows:
            {
                config: {
                    registerUrl: String,
                    signIn: String
                }
            }*/
        },
        data() {
            return { globalMessages: globalMessages };
        },
        mounted() {
            globalEventHandler.on(GLOBAL_EVENTS.DESKTOP_MENU.RESIZE_TO_MOBILE, this.hideSignInMenu);
        },
        beforeUnmount() {
            globalEventHandler.off(GLOBAL_EVENTS.DESKTOP_MENU.RESIZE_TO_MOBILE, this.hideSignInMenu);
        },
        methods: {
            hideSignInMenu() {
                this.isOpen = false;
            },
        },
    };
</script>

<style lang="scss">
    @use "./DesktopSignInMenu.scss";
</style>
